import { Injectable } from '@angular/core';
import { OccSavedCartAdapter } from '@spartacus/cart/saved-cart/occ';
 import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { OccEndpointsService, ConverterService, Occ } from '@spartacus/core';
import { Observable, map } from 'rxjs';
import { CustomCart } from '../../cart/models/custom-cart.model';
import { AppConstants } from '../../../SGRE-shared/constants/app-constant';
import { CART_NORMALIZER, SaveCartResult } from '@spartacus/cart/base/root';

@Injectable()
export class CustomSavedCartAdapter extends OccSavedCartAdapter {

  constructor(
    protected override http: HttpClient,
    protected override occEndpoints: OccEndpointsService,
    protected override converter: ConverterService
  ) {
    super(http, occEndpoints, converter);
  }

  override cloneSavedCart(
    userId: string,
    cartId: string,
    saveCartName: string,
    legalEntityId?: string,
  ): Observable<CustomCart> {
    const endpoint = this.getCloneSavedCartEndpoint(
      userId,
      cartId,
      saveCartName
    );

    let httpParams: HttpParams = new HttpParams()
      .append('legalEntityId', legalEntityId)
      .append('name', saveCartName)
      .append('cartName', saveCartName)
      .append('fields', AppConstants.DEFAULT_PAYLOAD.fields);

    return this.http.post<Occ.Cart>(endpoint, {}, { params: httpParams }).pipe(
      map((cartResponse) => (cartResponse as SaveCartResult).savedCartData),
      this.converter.pipeable(CART_NORMALIZER)
    );
  }

  deleteSavedCart(
    userId: string,
    cartId: string,
    legalEntityId?: string,
  ): Observable<{}> {
    let headers = new HttpHeaders();
    if (legalEntityId) {
      headers = headers.set('legalEntity', legalEntityId);
    }

    return this.http.delete<{}>(
      this.occEndpoints.buildUrl('deleteCart', {
        urlParams: { userId, cartId },
      }),
      { headers }
    );
  }
}